import { Handler, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/CatalogPages/Handlers/LoadCatalogPageByPath";
import {
    CatalogPage,
    CatalogPageResult,
    getCatalogPageByPath,
    GetCatalogPageByPathApiParameter,
} from "@tIntermatic/Services/INTCatalogServices";

type Parameter = {
    path: string;
} & HasOnSuccess<CatalogPage>;
type Props = {
    apiParameter: GetCatalogPageByPathApiParameter;
    apiResult: CatalogPageResult;
};

type HandlerType = Handler<Parameter, Props>;

export const IntRequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getCatalogPageByPath(props.apiParameter);
};

replaceInChain(chain, RequestDataFromApi, IntRequestDataFromApi);
